/**
 * Keyboard Shortcuts Help Modal Component - Using new Modal component
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalTitle,
} from '../../components/ui/modal';
import { Keyboard } from 'lucide-react';

const shortcuts = [
  { key: 'F1', action: 'Ajuda / Atalhos', description: 'Mostra esta janela' },
  { key: 'F2', action: 'Buscar Produto', description: 'Foca no campo de busca' },
  { key: 'F3', action: 'Cliente', description: 'Selecionar cliente' },
  { key: 'F4', action: 'Calculadora', description: 'Abre a calculadora' },
  { key: 'F5', action: 'Atualizar', description: 'Recarrega os dados' },
  { key: 'F6', action: 'Desconto', description: 'Aplicar desconto' },
  { key: 'F7', action: 'Cancelar Item', description: 'Remove último item do carrinho' },
  { key: 'F8', action: 'Finalizar', description: 'Abre tela de pagamento' },
  { key: 'F9', action: 'Mesa', description: 'Selecionar mesa' },
  { key: 'F10', action: 'Dividir', description: 'Dividir a conta' },
  { key: 'F11', action: 'Imprimir', description: 'Imprime a comanda' },
  { key: 'F12', action: 'Tema', description: 'Alterna tema claro/escuro' },
  { key: 'ESC', action: 'Fechar', description: 'Fecha modais abertos' },
  { key: 'Ctrl+Del', action: 'Limpar', description: 'Limpa todo o carrinho' },
];

export function ShortcutsHelpModal({ open, onOpenChange }) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="default">
        <ModalHeader>
          <ModalTitle className="flex items-center gap-2">
            <Keyboard className="h-5 w-5" />
            {t('pdv.shortcuts.title')}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="space-y-1">
            {shortcuts.map((shortcut) => (
              <div
                key={shortcut.key}
                className="flex items-center justify-between p-2 rounded-lg hover:bg-muted/50"
              >
                <div className="flex items-center gap-3">
                  <kbd className="kbd-lg">{shortcut.key}</kbd>
                  <span className="font-medium">{shortcut.action}</span>
                </div>
                <span className="text-sm text-muted-foreground">{shortcut.description}</span>
              </div>
            ))}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ShortcutsHelpModal;
